import { render, staticRenderFns } from "./MasterTeachers.vue?vue&type=template&id=1ab1a22e&"
import script from "./MasterTeachers.vue?vue&type=script&lang=js&"
export * from "./MasterTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports